import React from 'react';
import './Map.css';

const Map = () => {
  return (
    <section className="map-section" id="location">
      <h2>Konumumuz</h2>
      <div className="map-container">
        <iframe
          title="Şirket Konumu"
          src="https://maps.google.com/maps?q=36.79508073764698,34.62349365460275&z=15&output=embed"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};
export default Map;
